import { graphql } from '@/generated/gql';

export const INTAKE_DETAIL_QUERY = graphql(/* GraphQL */ `
  query IntakeDetailQuery($id: UUID!) {
    sevenbridges {
      chatSession(id: $id) {
        id
        status
        createdBy
        demandId
        demandResponsibleUsers
        demandSequenceNumber
        chatMessages {
          id
          sequence
          status
          variant
          message
          role
        }
      }
    }
  }
`);
